package org.hs_soft.runmynesto.domain.model.home.template

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.model.general.TitleEnum
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class TemplateInfoHeaderEnum : TitleEnum {
    GENERAL,
    CHECKOUT,
//    SURCHARGE_IN_HOUSE,
    OPTIONS
    ;

    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            GENERAL -> strings.general
            CHECKOUT -> strings.devices
//            SURCHARGE_IN_HOUSE -> strings.surchargeInHouse
            OPTIONS -> strings.options
        }
    }

    override val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                GENERAL -> strings.general
                CHECKOUT -> strings.devices
//                SURCHARGE_IN_HOUSE -> strings.surchargeInHouse
                OPTIONS -> strings.options
            }
        }
}